import { ApplicantType } from "@versatile-credit-apply/omni-apply-client"
import type { FormSection } from "../sections"
import type {
  FormStepId,
  DynamicFormFactory,
  DynamicFormFactoryContext,
} from "../dynamic-form-factory"

type SectionGetter = (context: DynamicFormFactoryContext) => FormSection[]

interface FormFactoryConfig {
  steps: FormStepId[]
  jointSteps?: FormStepId[]
  primarySections: SectionGetter
  jointSections: SectionGetter
  done?: () => string
}

export const defineFormFactory = (
  id: string,
  config: FormFactoryConfig
): DynamicFormFactory => {
  return {
    id,
    steps: config.steps,
    jointSteps: config.jointSteps || config.steps,
    sectionsFor: (applicantType, context) =>
      applicantType === ApplicantType.PRIMARY
        ? config.primarySections(context)
        : config.jointSections(context),
    done: config.done
  }
}
